/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import { get } from "@ember/object";
import ScaleSurveyEditionFormComponent from "parog-web/components/abstract/scale-survey-edition-form";
import type { Payload } from "parog-web/components/forc/abstract/journal-event-based-component";
import QidsDeclaredJournalEvent from "parog-web/models/qids-declared-journal-event";
import qidsScoreDescription from "parog-web/utils/qids-score-description";

export default class QidsEditionFormComponent extends ScaleSurveyEditionFormComponent {
  static forcDisplayName =
    "Quick Inventory of Depressive Symptomatology (QIDS)";
  static fullComponentId = "scale-surveys/qids-edition-form";
  static journalEventClass = QidsDeclaredJournalEvent;

  get numberOfItems() {
    return 16;
  }

  get maximalScore() {
    return 27;
  }

  get validationNames() {
    return [
      "L'insomnie d'endormissement",
      "L'insomnie du milieu de la nuit",
      "L'insomnie du petit matin",
      "L'hypersomnie",
      "L'humeur",
      "L'appétit (diminution)",
      "L'appétit (augmentation)",
      "Le poids (perte)",
      "Le poids (augmentation)",
      "La concentration / prise de décision",
      "L'image de soi",
      "L'idéation suicidaire",
      "L'implication dans les activités",
      "L'énergie / fatigabilité",
      "Le ralentissement psychomoteur",
      "L'agitation psychomotrice"
    ];
  }

  // payload will either be a changeset (when template refreshes),
  // or a POJO (when the form is saved).
  _computeScore(payload: Payload) {
    /* eslint-disable @typescript-eslint/no-this-alias */
    const self = this;
    function getValue(i: number) {
      const key = self.questionIds[i - 1];
      return parseInt(get(payload, key) as string);
    }

    // Score formula :
    // (Maximum de (Q1, Q2, Q3, Q4)) + Q5 + (Maximum de (Q6, Q7, Q8, Q9)) + Q10 + Q11 + Q12 + Q13 + Q14 + (Maximum de (Q15, Q16))
    const number =
      Math.max(getValue(1), getValue(2), getValue(3), getValue(4)) +
      getValue(5) +
      Math.max(getValue(6), getValue(7), getValue(8), getValue(9)) +
      getValue(10) +
      getValue(11) +
      getValue(12) +
      getValue(13) +
      getValue(14) +
      Math.max(getValue(15), getValue(16));

    return {
      number,
      description: qidsScoreDescription(number)
    };
  }
}
